import { jsx as _jsx } from "react/jsx-runtime";
import BaseFieldDetail from "../base/detail";
import { FieldViewType } from "../viewType";
/** <b>Composant en mode consultation/detail d'un champ de type id</b>*/
export default function IdFieldDetail(_a) {
    var fieldName = _a.fieldName, record = _a.record;
    return (_jsx(BaseFieldDetail, { viewType: FieldViewType.DETAIL, fieldName: fieldName, record: record }));
}
